<template>
  <v-toolbar
    :color="$vuetify.breakpoint.mdAndDown ? '#28243d' : 'transparent'"
    flat
    :height="68"
  >
    <v-toolbar-title class="text-h6 font-weight-medium">
      <v-icon
        left
        :class="{ 'mr-3': pageStore.isFullScreen }"
        color="white"
        :large="pageStore.isFullScreen"
      >
        {{ pageStore.pageIcon }}
      </v-icon>
      <span
        class="white--text"
        :class="pageStore.isFullScreen ? 'text-h6' : 'text-body-1'"
        >{{ pageStore.pageTitle }}</span
      >
    </v-toolbar-title>

    <v-spacer></v-spacer>


      <v-card
        flat
        class="d-flex align-center"
        v-if="
          pageStore.hasActions ||
          pageStore.hasFullScreen ||
          pageStore.hasDownloadApi ||
          pageStore.hasDownload ||
          pageStore.hasDateRange
        "
      >
        <Fullscreen
          v-if="pageStore.hasFullScreen && !$vuetify.breakpoint.mdAndDown"
        />
        <DownloadApi v-if="pageStore.hasDownloadApi && pageStore.pageTitle !== 'Tedarikçi Onay Formları'" />
        <SupplierFormDownload v-else-if="pageStore.hasDownloadApi && pageStore.pageTitle === 'Tedarikçi Onay Formları'" />
        <Download v-if="pageStore.hasDownload" />
        <DateRange v-if="pageStore.hasDateRange" />

        <slot name="action" v-if="pageStore.hasActions"></slot>
      </v-card>

  </v-toolbar>
</template>

<script>
// Pinia
import { usePageStore } from "@/stores/pageHeader";

// Components
import Download from "./Download.vue";
import DownloadApi from "./DownloadApi.vue";
import SupplierFormDownload from "./SupplierFormDownload.vue";
import DateRange from "./DateRange.vue";
import Fullscreen from "./Fullscreen.vue";

export default {
  components: {
    Download,
    DownloadApi,
    SupplierFormDownload,
    DateRange,
    Fullscreen,
  },

  setup(props) {
    const pageStore = usePageStore();

    return {
      pageStore,
    };
  },
};
</script>
